import { render, staticRenderFns } from "./Card_Organisation.vue?vue&type=template&id=6308901f&"
import script from "./Card_Organisation.vue?vue&type=script&lang=js&"
export * from "./Card_Organisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports